<template lang="pug">
  .form-item
    div.mt-2.pa-4(style="border:1px solid var(--v-basic400); border-radius: 4px;")
      div.d-flex.align-center
        div.s1.primary500--text {{ form.name }}
        v-spacer
        div.f2.basic600--text {{ checkTimeSince(form.created) }}
      div.d-flex.align-center.mt-3
        v-btn.button-AA-small(color="primary" small outlined depressed style="background-color: var(--v-basic600T08)" @click="showLandingFormDialog = true") {{ $t('continue') }}
        v-btn.button-Aa-small.ml-3(color="primary" text small depressed @click="openDeleteDialog = true") {{ $t('delete') }}

    .modals
      edit-landing-form(v-if="showLandingFormDialog" :open.sync="showLandingFormDialog" :parentForm.sync="form" :company="company")
      y-dialog(v-if="openDeleteDialog" v-model='openDeleteDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_form') }}
          v-card-text.p2.primary500--text.px-4 {{ $t('are_you_sure_delete') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openDeleteDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete' :loading="isLoading" dark)
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import { mapActions, mapState } from 'vuex'
import EditLandingForm from '@/components/dialogs/localads/EditLandingForm.vue'

export default {
  name: 'LandingItemProgress',
  props: ['parentForm', 'company', 'statusd'],
  components: { EditLandingForm },
  data: () => ({
    isLoading: false,
    openDeleteDialog: false,
    showLandingFormDialog: false,
    intervals: [
      { label: 'year', seconds: 31536000 },
      { label: 'month', seconds: 2592000 },
      { label: 'day', seconds: 86400 },
      { label: 'hour', seconds: 3600 },
      { label: 'minute', seconds: 60 },
      { label: 'second', seconds: 1 }
    ],
  }),
  computed: {
    ...mapState('user', ['member']),
    form: {
      get() {
        return this.parentForm
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    startDelete() {
      this.isLoading = true
      this.axios.patch(`/forms/${this.form.id}/`, { status: 'deleted' })
        .then(() => {
          this.$emit('deleted', this.form)
          this.openDeleteDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    checkTimeSince (date) {
      try {
        if (typeof date !== 'object') {
          date = new Date(date)
        }
        const seconds = Math.floor((Date.now() - date.getTime()) / 1000)
        if (seconds < 0) {
          throw new Error('Current time is smaller than given datetime')
        }
        const interval = this.intervals.find(i => i.seconds < seconds)
        const count = Math.floor(seconds / interval.seconds)
        return `${count} ${interval.label}${count !== 1 ? 's' : ''} ago`
      } catch {/* */}
    }
  }
}
</script>

<style lang="scss" scoped>
</style>

<i18n>
{
  "en": {
    "continue": "Continue",
    "are_you_sure_delete": "Are you sure you want to delete this form? This form will be deleted permanently."
  },
  "id": {
    "continue": "Lanjutkan",
    "are_you_sure_delete": "Anda yakin ingin menghapus format ini? Format ini akan dihapus secara permanen."
  }
}
</i18n>